import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import { cancelTransaction } from '../../../actions/transaction';

import Button from '../../Button';

import messages from './CancelTransactionMessage.messages';

const label = (
  <FormattedMessage {...messages.label}>{(text) => text}</FormattedMessage>
);

const CancelTransactionMessage = (props) => (
  <div className="bg-white pa4">
    <h2>{label}</h2>
    <p className="lh-copy">
      <FormattedMessage {...messages.started} />
      <br />
      <FormattedMessage {...messages.finish} />
    </p>

    <Button
      isDisabled={props.isCancelling}
      onClick={() => props.cancelTransaction()}
    >
      <FormattedMessage {...messages.return} />
    </Button>
  </div>
);

CancelTransactionMessage.propTypes = {
  cancelTransaction: PropTypes.func.isRequired,
  isCancelling: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ transaction }) => ({
  isCancelling: transaction.isCancelling,
});

const mapDispatchToProps = (dispatch) => ({
  cancelTransaction: () => dispatch(cancelTransaction()),
});

export { label };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CancelTransactionMessage); // eslint-disable-line max-len
